function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 13.333v-.5A2.833 2.833 0 009.167 10h-5a2.833 2.833 0 00-2.833 2.833v.5",
  stroke: "#969799",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "6.667",
  cy: "4.667",
  stroke: "#969799",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  r: "2.667"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.667 6v2.667M14 7.333h-2.666",
  stroke: "#969799",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));